import produce from 'immer';
import { ActionTypes } from './Home.actions';
import { namespaces, getNamespace } from './Home.schema';

export const initialState = {
    [namespaces.preview]: {
        scrollPosition: 0,
        loaded: false,
        days: {},
        daysOrder: [],
        years: [],
        applications: [],
    },
    [namespaces.archive]: {
        scrollPosition: 0,
        loaded: false,
        days: {},
        daysOrder: [],
        years: [],
        applications: [],
    },
    applicationFiles: [],
    archivedCount: null,
    archivedCountLoaded: false
};
const reducer = (state = initialState, action) => produce(state, (draft) => {
    switch (action.type) {
        case ActionTypes.resetApplications: {
            return initialState;
        }
        case ActionTypes.fetchApplications: {
            const { archived } = action.payload;
            draft[getNamespace(archived)].loaded = false;
            return draft;
        }
        case ActionTypes.fetchApplicationsCompleted: {
            const { days, daysOrder, applications, years, archived } = action.payload;
            if (applications) {
                draft[getNamespace(archived)].days = days;
                draft[getNamespace(archived)].daysOrder = daysOrder;
                draft[getNamespace(archived)].applications = applications;
                draft[getNamespace(archived)].years = years;
                draft[getNamespace(archived)].loaded = true;
                return draft;
            }
            return state;
        }
        case ActionTypes.saveScrollPosition: {
            const { archived, scrollPosition } = action.payload;
            draft[getNamespace(archived)].scrollPosition = scrollPosition;
            return draft;
        }
        case ActionTypes.fetchArchivedCountCompleted: {
            const { count } = action.payload;
            draft.archivedCount = count;
            return draft;
        }
        case ActionTypes.fetchFileCompleted: {
            const { applicationId, fileId, file } = action.payload;
            draft.applicationFiles[applicationId] = {};
            draft.applicationFiles[applicationId][fileId] = file;
            return draft;
        }
        default: {
            return state;
        }
    }
});
export default reducer;
